/**
 * Top-level demo-security wrapper. Mounts the 3 client-side security layers
 * GLOBALLY whenever the active session is is_demo=true, so the watermark and
 * shortcut lockdown follow the viewer across every route, not just /admin/*.
 *
 * Layers:
 *   1. <DemoSecurityGate />        — Confidential-Demonstration click-through
 *   2. <DemoWatermark />           — diagonal tiled overlay + bottom-right chip + Layer 7 audit markers
 *   3. useDemoLockdown()           — keyboard / right-click / drag / copy / select disabled
 *
 * On real-admin sessions (or unauthenticated), all three are silent no-ops.
 */
import DemoSecurityGate from "@/components/security/DemoSecurityGate";
import DemoWatermark from "@/components/security/DemoWatermark";
import useDemoLockdown from "@/hooks/useDemoLockdown";

export function DemoSecurityProvider({ children }) {
  useDemoLockdown();
  return (
    <>
      <DemoSecurityGate />
      <DemoWatermark />
      {children}
    </>
  );
}
